
import "../styles/ComingSoon.css";

const ComingSoon = () => {
    return (
        <div className="coming-soon">
        <h1>Coming Soon....</h1>
        </div>
    );
}

export default ComingSoon;